module.exports = __webpack_public_path__ + "img/product4.jpg?c7263d9c1996fd10c66b34eb0edfd70e";